module.exports = __webpack_public_path__ + "static/media/9H.3ac1dc84.svg";